import {EpLayer} from "./layer";
import {Style} from "ol/style";
import {Feature} from "ol";
import {Point} from "ol/geom";
import {fromLonLat} from "ol/proj";
import moment from "moment";
import {observationsStyle} from "../styles/observations";

export class EpInventoryObservations extends EpLayer {
    constructor(map) {
        super(map);

        this.style = observationsStyle;
        this.title = 'Zaobserwowana zwierzyna';
        this.name = 'observations';
        this.farStyle = new Style();

        return this;
    }

    addObservation(observation, zoomLimit = 13.5) {
        if(!observation.longitude || !observation.latitude) return null;

        let feature = new Feature({
            geometry: new Point(fromLonLat([observation.longitude, observation.latitude])),
            zoomLimit,
            type: 'observation',
            observation_id: observation.id,
            tooltip: `
                        <span style="font-size: 12px;">${moment(observation.date).format('DD/MM/YYYY HH:mm')}</span><br />
                        ${observation.items.map(item => {
                let animal = item.animalType.name;

                if(item.animalType.animals.length > 1) {
                    animal += ' ' + item.animal.name;
                }

                if(parseInt(window._inventory_type ?? -1) === 4) {
                    return `${animal}`
                }

                return `- ${animal} (${item.quantity} szt.)`
            }).join('<br />')}<br /><br />
                        ${observation.author}
                    `
        });
        feature.setId('observation-' + observation.id);
        feature.set('data', observation)
        feature.set('number', observation.number)

        this.getSource().addFeature(feature);

        return feature;
    }

}
